import _ from 'lodash';
import GraphicBlockPoint from '../../roadMapComponent/graphics/blockPoint';
import GraphicPanoramaPoint from './panoramaPoint';

class Graphic {
  static buildGraphic(payload, stage) {
    if (payload.type === 'point') {
      if (payload.group_type === 'PanoramaPoint' && payload.property.type === '91') {
        return new GraphicPanoramaPoint(payload, stage);
      }
    }
    if (payload.type === 'blockPoint') {
      return new GraphicBlockPoint(payload, stage);
    }

    return null;
  }
}

export default Graphic;
